import React from "react";
import styles from "./Company.css";
import { Panel, Button, Row, Col } from "react-bootstrap";
import { /* isA, isReporter,*/ isDiff, getStrValue } from "../../store/utility";
//import * as UIConstants from "../../components/UI/UIConstants";
//import Switch from "rc-switch";

export default class Company extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data,
      originalData: this.props.data,
      editing: false || this.props.editing,
      name: {
        value: this.getPropValue("data", "name"),
        defaultValue: "Nom",
        displayDefault: this.getPropValue("data", "name").length === 0,
      },
      rcs: {
        value: this.getPropValue("data", "rcs"),
        defaultValue: "RCS",
        displayDefault: this.getPropValue("data", "rcs").length === 0,
      },
      siret: {
        value: this.getPropValue("data", "siret"),
        defaultValue: "SIRET",
        displayDefault: this.getPropValue("data", "siret").length === 0,
      },
      dependOn: {
        value: this.getPropValue("data", "dependOn"),
        defaultValue: "ATIS_SYSTEM",
        displayDefault: this.getPropValue("data", "dependOn").length === 0,
      },
      repName: {
        value: this.getPropValue("data", "repName"),
        defaultValue: "",
        displayDefault: this.getPropValue("data", "repName").length === 0,
      },
    };
  }
  getPropValue = (obj, property) => {
    if (this.props[obj] === null || this.props[obj][property] === null) {
      return "";
    }

    return this.props[obj][property];
  };
  //LifeCycle
  componentWillReceiveProps(nextProps) {
    if (
      isDiff(this.props.data, nextProps.data) ||
      this.props.data !== nextProps.data ||
      this.props.editing !== nextProps.editing
    ) {
      var _state = this.state;
      _state["data"] = nextProps.data;
      _state["originalData"] = nextProps.data;
      _state["editing"] = nextProps.editing;
      _state["name"].value = getStrValue(nextProps.data.name);
      _state["name"].displayDefault =
        getStrValue(nextProps.data.name).length === 0;
      _state["rcs"].value = getStrValue(nextProps.data.rcs);
      _state["rcs"].displayDefault =
        getStrValue(nextProps.data.rcs).length === 0;
      _state["siret"].value = getStrValue(nextProps.data.siret);
      _state["siret"].displayDefault =
        getStrValue(nextProps.data.siret).length === 0;
      _state["dependOn"].value = getStrValue(nextProps.data.dependOn);
      _state["dependOn"].displayDefault =
        getStrValue(nextProps.data.dependOn).length === 0;
      _state["repName"].value = getStrValue(nextProps.data.repName);
      _state["repName"].displayDefault =
        getStrValue(nextProps.data.repName).length === 0;
      this.setState(_state);
    }
  }

  //Handler
  resetHandler = (event) => {
    event.preventDefault();
    var _originalData = this.state.originalData;
    this.setState({ data: _originalData });
    this.props.disableOthersEditing(null);
  };

  enabledHandler = (event) => {
    event.preventDefault();
    var _data = this.state.data;
    _data.enabled = !_data.enabled;
    this.props.saveOrUpdate(_data);
  };

  saveHandler = (event) => {
    event.preventDefault();
    var _data = this.state.data;
    _data.name = (this.state.name.value || "").trim();
    _data.rcs = this.state.rcs.value;
    _data.siret = this.state.siret.value;
    _data.repName = this.state.repName.value;
    _data.dependOn = this.state.dependOn.value;
    if (_data.id === null) {
      this.props.saveOrUpdate(_data);
    } else {
      // 22/10/2026 : mise a jour sans renvoyer les sites
      this.props.saveOrUpdate({
        id: _data.id, name: _data.name, rcs: _data.rcs, siret: _data.siret,
        repName: _data.repName, dependOn: _data.dependOn
      });
    }
  };

  // 22/10/2026 : desactiver / reactiver un client (il reste en base avec son historique)
  activatedHandler = (event) => {
    event.preventDefault();
    const _data = this.state.data;
    const desactiver = _data.activated !== false;
    const msg = desactiver
      ? "Désactiver le client « " + _data.name.trim() + " » ?\n\nIl reste en base avec tout son historique (demandes, bons, sites), mais n'est plus proposé pour les nouvelles demandes, les nouveaux sites et contacts, Demandes reçues et Maintenance."
      : "Réactiver le client « " + _data.name.trim() + " » ?";
    if (!window.confirm(msg)) {
      return;
    }
    this.props.saveOrUpdate({ id: _data.id, activated: !desactiver });
  };

  editHandler = (event) => {
    event.preventDefault();
    this.props.disableOthersEditing(this.props.data.id);
  };

  validChangeHandler = () => {
    return (
      this.state.name.value !== this.state.data.name ||
      this.state.rcs.value !== this.state.data.rcs ||
      this.state.siret.value !== this.state.data.siret ||
      this.state.dependOn.value !== this.state.data.dependOn
    );
  };

  changeInputHandler = (event, obj) => {
    var _state = this.state;
    const stateId = event.target.id.substring(0, event.target.id.indexOf("_"));
    _state[stateId].value = event.target.value;
    _state[stateId].displayDefault =
      event.target.value.trim().length === 0;
    this.setState(_state);
  };

  changeSelectHandler = (event, obj) => {
    var _state = this.state;
    const stateId = event.target.id.substring(0, event.target.id.indexOf("_"));

    _state[stateId].value = event.target.value;
    _state[stateId].displayDefault = event.target.value.trim().length === 0;
    this.setState(_state);
  };
  
  changeSwitchHandler = (id, value) => {
    var _state = this.state;
    _state[id].value = value;
    this.setState(_state);
  };

  displayDefault = (val) => {
    if (val.displayDefault) {
      return val.defaultValue;
    }
    return val.value;
  };
  render() {
    if (this.state.data === null || !this.state.data) {
      return null;
    }

    
    //const data = this.state.data;
    const editing = this.props.editing;
    return (
      <Panel bsStyle={this.state.data.activated === false ? "default" : "primary"}>
        <Panel.Heading
          className="clearfix"
          style={{ padding: "5px", paddingLeft: "10px" }}
        >
          <div className="pull-left">
            {this.state.data.name}
            {this.state.data.activated === false ? (
              <span style={{ marginLeft: "8px", fontStyle: "italic" }}>(désactivé)</span>
            ) : null}
          </div>
        </Panel.Heading>
        <Panel.Body style={{ paddingTop: "5px" }}>
          <Row>
            <Col sm={1}>
              <i className="fa fa-building" />
            </Col>
            <Col sm={10}>
              <input
                type="text"
                id={`name_${this.state.data.id}`}
                style={{ textAlign: "left" }}
                placeholder={editing ? this.state.name.defaultValue : ""}
                className={
                  editing
                    ? this.state.name.displayDefault
                      ? styles.editableField
                      : styles.editableExistField
                    : styles.normalField
                }
                disabled={!editing}
                onChange={(event) => this.changeInputHandler(event)}
                value={this.state.name.value}
              />
            </Col>
            <Col sm={1} />
          </Row>

          {this.state.editing ? (
            <React.Fragment>
              <Row>
                <Col sm={1}>
                  <i className="fa fa-envelope" />
                </Col>
                <Col sm={10}>
                  <select
                    id={`dependOn_${this.state.data.id}`}
                    style={{ color: "#000" }}
                    value={this.state.dependOn.value}
                    onChange={(event) => this.changeSelectHandler(event)}
                  >
                    <option value="ATIS_SYSTEM">ATIS SYSTEM</option>
                    <option value="EVE_FROID">EVE FROID</option>
                  </select>
                </Col>
                <Col sm={1} />
              </Row>
              <Row></Row>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Row>
                <Col sm={1}>
                  <i className="fa fa-envelope" />
                </Col>
                <Col sm={10}>
                  <input
                    id={`dependOnTxt_${this.state.data.id}`}
                    style={{ textAlign: "left" }}
                    className={styles.normalField}
                    disabled={true}
                    value={this.state.dependOn.value}
                  />
                </Col>
                <Col sm={1} />
              </Row>
              <Row>
                <Col sm={1}>
                  <i className="fa fa-folder" />
                </Col>
                <Col sm={10}>
                  <input
                    type="text"
                    id={`repName_${this.state.data.id}`}
                    style={{ textAlign: "left" }}
                    placeholder=""
                    className={styles.normalField}
                    disabled={true}
                    value={this.state.repName.value}
                  />
                </Col>
                <Col sm={1} />
              </Row>
            </React.Fragment>
          )}
        </Panel.Body>
        <Panel.Footer className="clearfix">
          <div className="pull-left">
            {this.props.editing ? (
              this.state.data.id === null ? (
                <Button
                  bsStyle="danger"
                  bsSize="xsmall"
                  onClick={(event) => this.props.hideCompany(event)}
                >
                  <i className="fa fa-ban" />
                  &nbsp;Annuler
                </Button>
              ) : (
                <React.Fragment>
                <Button
                  bsStyle="danger"
                  bsSize="xsmall"
                  onClick={(event) => this.resetHandler(event)}
                >
                  <i className="fa fa-ban" />
                  &nbsp;Annuler
                </Button>
                &nbsp;
                <Button
                  bsStyle={this.state.data.activated === false ? "success" : "warning"}
                  bsSize="xsmall"
                  onClick={(event) => this.activatedHandler(event)}
                >
                  <i className={this.state.data.activated === false ? "fa fa-undo" : "fa fa-archive"} />
                  &nbsp;{this.state.data.activated === false ? "Réactiver" : "Désactiver"}
                </Button>
                </React.Fragment>
              )
            ) : null}
          </div>
          <div className="pull-right">
            {this.props.editing ? (
              <Button
                bsStyle="success"
                bsSize="xsmall"
                disabled={!this.validChangeHandler()}
                onClick={(event) => this.saveHandler(event)}
              >
                <i className="fa fa-check" />
                &nbsp;Valider
              </Button>
            ) : (
              <Button
                bsStyle="info"
                bsSize="xsmall"
                onClick={(event) => this.editHandler(event)}
              >
                <i className="fa fa-edit" />
                &nbsp;&Eacute;diter
              </Button>
            )}
          </div>
        </Panel.Footer>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Company/Company.js